import { Stack, Tab, Tabs } from "@mui/material"
import { routesProfile } from "../../../consts"
import { NavLink, useLocation } from "react-router-dom"
import { TabsStyle } from "./style"

export const TeamsTabs = () => {
    const location = useLocation()
    const pathname = location.pathname
    const currentTab = pathname.endsWith('/participating')
    ? 3
    : pathname.endsWith('/subscriptions')
        ? 1
        : pathname.endsWith('/mine')
            ? 2
            : 0

    return (
        <Stack direction="column" gap={{ xs: 1.5, sm: 2 }} mb={2} sx={{ minWidth: 0 }}>
            <Tabs
                value={currentTab}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={TabsStyle}
            >
                <Tab label="Все" component={NavLink} to={`/${routesProfile.TEAMS.path}`} end />
                <Tab label="Подписки" component={NavLink} to={`/${routesProfile.TEAMS.path}/subscriptions`} />
                <Tab label="Мои" component={NavLink} to={`/${routesProfile.TEAMS.path}/mine`} />
                <Tab label="Участвую" component={NavLink} to={`/${routesProfile.TEAMS.path}/participating`} />
            </Tabs>
          </Stack>
    )
}